import { CatalogoService } from './servicios/catalogo.service';
import { ItemSelect } from './modelos/itemselect';
import { AuthService } from './servicios/auth.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { HttpClient } from '@angular/common/http';




@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  endpoint = 'https://us-central1-adunascotizador.cloudfunctions.net/httpEmail';

  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;

  tiposOperacion: ItemSelect[];
  aduanas;
  tiposTransporte;
  honorarios;
  otrosServicios;
  emailPattern = "^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$";

  // tslint:disable-next-line: max-line-length
  constructor(private formBuilder: FormBuilder, private authService: AuthService, private catalogoService: CatalogoService, private http: HttpClient) { }

  ngOnInit() {


    //Se loguea el usuario
    this.authService.login('code.desarrollo@gmail.com', '123456').then(() => {
    }).catch(() => {
    });

    //Se llenan los catalogos
    this.tiposOperacion = this.catalogoService.getTiposOperacion();


    this.catalogoService
      .getAduanas()
      .subscribe(res => (this.aduanas = res));

    this.firstFormGroup = this.formBuilder.group({
      ctrlNombre: ['', Validators.required],
      ctrlCorreo: ['', Validators.compose([Validators.required, this.emailValidator])],
      // tslint:disable-next-line: max-line-length
      ctrlTelefono: ['', [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/), Validators.maxLength(10), Validators.minLength(10)]],
    });

    this.secondFormGroup = this.formBuilder.group({
      ctrlDescripcion: ['', Validators.required],
      ctrlObservaciones: []
    });

    this.thirdFormGroup = this.formBuilder.group({
      ctrlAduana: [],
      ctrlTipoOperacion: [],
      ctrlTipoTransporte: [],
      ctrlHonorarios: [],
      ctrlOtrosServicios: []
    });
  }

  emailValidator(control) {
    if (control.value) {
      const matches = control.value.match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }

  onAduanasChange(ob) {
    let selectedAduana = ob.value;

    this.catalogoService
      .getTransportes(selectedAduana)
      .subscribe(res => (this.tiposTransporte = res));

  }

  onTiposOperacionChange(ob) {
    let selectedTipo = ob.value;

    this.catalogoService
      .getHonorarios(Number(selectedTipo))
      .subscribe(res => {
        this.honorarios = res;
      });

    this.catalogoService
      .getOtrosServicios(Number(selectedTipo))
      .subscribe(res => {
        this.otrosServicios = res;
      });

  }

  sendEmail() {

    // tslint:disable-next-line: max-line-length
    let plantillaCorreo = '<!DOCTYPE html> <html> <head> <style> p{font-family: \'Arial\', cursive;} table { table-layout: fixed; width: 100%; border-collapse: collapse; border: 2px solid black; font-family: \'Arial\', cursive; } thead th:nth-child(1) { width: 40%; } thead th:nth-child(2) { width: 20%; } thead th:nth-child(3) { width: 20%; } thead th:nth-child(4) { width: 20%; } th, td { padding: 20px; } tbody tr:nth-child(odd) { background-color: #f8D983; } tbody tr:nth-child(even) { background-color: #D7BB75; } tbody td{ border: 2px solid black; } thead th, tfoot th, tfoot td { background: linear-gradient(to bottom, rgb(120,104,77), rgba(0,0,0)); border: 2px solid black; color: white; } </style> </head> <body> <center><h1>Casa Aduanas Mendoza</h1></center> <p> Gracias <b>$NOMBRE$</b> por confiar en nosotros. La cotizacion de <b>$DESCRIPCION$</b> se enlista en la siguiente tabla.  </p> <table> <thead> <tr> <th>Concepto</th> <th>Unidad</th> <th>Moneda</th> <th>Importe</th> </tr> </thead> <tbody> $CONTENIDOTABLA$ </tbody> <tfoot> <tr> <td colspan="3" align="right">Total</td> <td align="right">$TOTALTABLA$</td> </tr> </tfoot> </table> <p><b>Nota:</b> La cotizacion puede variar un poco en los precios mostrados en la tabla </p> </body> </html>'

    const uno = this.firstFormGroup.value;
    console.log(uno);

    const dos = this.secondFormGroup.value;
    console.log(dos);

    const tres = this.thirdFormGroup.value;
    console.log(tres);

    plantillaCorreo = plantillaCorreo.replace('$NOMBRE$', uno['ctrlNombre']);

    let nombreAduana = '';
    let nombreTipoTransporte = '';
    let nombreTipoOperacion = '';

    let contenidoTabla = '';
    let importe = 0;

    this.aduanas.forEach(element => {
      if (element.payload.doc.id === tres['ctrlAduana']) {
        nombreAduana = element.payload.doc.data().Nombre;
        //console.log('NOMBRE ADUANA: ' + nombreAduana);
      }
    });

    this.tiposOperacion.forEach(element => {
      if (element.value === tres['ctrlTipoOperacion']) {
        nombreTipoOperacion = element.description;
        //console.log('nombreTipoOperacion: ' + nombreTipoOperacion);
      }
    });

    this.tiposTransporte.forEach(element => {
      if (element.payload.doc.id === tres['ctrlTipoTransporte']) {
        nombreTipoTransporte = element.payload.doc.data().Transporte;
        //console.log('nombreTipoTransporte: ' + nombreTipoTransporte);
      }
    });

    this.honorarios.forEach(element => {
      if (element.payload.doc.id === tres['ctrlHonorarios']) {
        contenidoTabla += '<tr><td align="justify">'+element.payload.doc.data().Descripcion +'</td><td align="left">'+ element.payload.doc.data().Unidad+'</td><td align="right">'+ element.payload.doc.data().Moneda +'</td><td align="right"> $ '+ element.payload.doc.data().Monto+'</td></tr>';
        importe += element.payload.doc.data().Monto;
      }
    });

    tres['ctrlOtrosServicios'].forEach(clave => {
      this.otrosServicios.forEach(element => {
        if (element.payload.doc.id === clave) {
          contenidoTabla += '<tr><td align="justify">'+element.payload.doc.data().Descripcion +'</td><td align="left">'+ element.payload.doc.data().Unidad+'</td><td align="right">'+ element.payload.doc.data().Moneda +'</td><td align="right"> $ '+ element.payload.doc.data().Monto+'</td></tr>';
          importe += element.payload.doc.data().Monto;
        }
      });
    });

    plantillaCorreo = plantillaCorreo.replace('$DESCRIPCION$', dos['ctrlDescripcion'] + '</b> para la aduana de <b>' + nombreAduana + '</b> para  <b>' + nombreTipoOperacion + ' </b> y transporte <b>' + nombreTipoTransporte + '</b>');

    plantillaCorreo = plantillaCorreo.replace('$CONTENIDOTABLA$', contenidoTabla);

    plantillaCorreo = plantillaCorreo.replace('$TOTALTABLA$', '$ ' + importe.toString());

    const valores = {
      'Nombre': uno['ctrlNombre'],
      'Correo': uno['ctrlCorreo'],
      'Telefono': uno['ctrlTelefono'],
      'Descripcion': dos['ctrlDescripcion'],
      'Observaciones': dos['ctrlObservaciones'],
      'Aduana': tres['ctrlAduana'],
      'Transporte': tres['ctrlTipoTransporte'],
      'Operacion': tres['ctrlTipoOperacion'],
      'Honorario': tres['ctrlHonorarios'],
      'OtrosServicios': tres['ctrlOtrosServicios'],
      'Mensaje': plantillaCorreo
    };

    console.log('Concatenados');
    console.log(valores);

    console.log('Enviar correo');

    this.catalogoService.guardarCotizacion(valores);
  }
}
